export const ScallingTypes = [
    { key: "SystemSize", text: "SystemSize" },
    { key: "Investment", text: "Investment" },
    { key: "Students", text: "Students" }]
